import _ from 'lodash';

export const UPDATE_CURRENT_TIME = 'UPDATE CURRENT TIME';
export const SELECT_PLAYERS = 'TA SELECT PLAYERS';
export const UPDATE_DOTS = 'UPDATE DOTS';
export const UPDATE_LINES = 'UPDATE LINES';
export const UPDATE_HINTS = 'UPDATE HINTS';
export const UPDATE_SHAPES = 'UPDATE SHAPES';
export const SET_CURRENT_PLAYER = 'TA SET CURRENT PLAYER';
export const SET_PLAYER_TO_START = 'TA SET PLAYER TO START';
export const RESTART = 'TA RESTART';
export const UPDATE_STATS = 'TA UPDATE STATS';
export const SET_OPTIONS = 'TA SET OPTIONS';
export const SET_OPTION = 'TA SET OPTION';
export const SET_FROM_TO = 'SET FROM TO';
export const START_PLAYBACK = 'START PLAYBACK';
export const STOP_PLAYBACK = 'STOP PLAYBACK';
export const PAUSE_PLAYBACK = 'PAUSE PLAYBACK';
export const SELECT_SIZE = 'TA SELECT SIZE';
export const SELECT_SKILL = 'TA SELECT SKILL';

export const updateCurrentTime = () => ({ type: UPDATE_CURRENT_TIME, time: _.now() });
export const selectPlayers = players => ({ type: SELECT_PLAYERS, players });
export const updateDots = dots => ({ type: UPDATE_DOTS, dots });
export const updateLines = lines => ({ type: UPDATE_LINES, lines });
export const updateHints = hints => ({ type: UPDATE_HINTS, hints });
export const updateShapes = shapes => ({ type: UPDATE_SHAPES, shapes });
export const setCurrentPlayer = player => ({ type: SET_CURRENT_PLAYER, player });
export const setPlayerToStart = player => ({ type: SET_PLAYER_TO_START, player });
export const restart = initial => ({ type: RESTART, initial });
export const updateStats = stats => ({ type: UPDATE_STATS, stats });
export const setOptions = options => ({ type: SET_OPTIONS, options });
export const setOption = payload => ({ type: SET_OPTION, payload });
export const setFromTo = payload => ({ type: SET_FROM_TO, payload });
export const startPlayback = () => ({ type: START_PLAYBACK });
export const stopPlayback = () => ({ type: STOP_PLAYBACK });
export const pausePlayback = resume => ({ type: PAUSE_PLAYBACK, resume });
export const selectSize = size => ({ type: SELECT_SIZE, size });
export const selectSkill = skill => ({ type: SELECT_SKILL, skill });
